export const PH_TARIFF_CODE = "2936270000";
export const PH_GOODS_DESCRIPTION = "natural wellbeing supplements";
export const PH_HEALF_EORI_UK = "GB385509270000";
export const PH_HEALF_VAT_UK = "385509270";
export const PH_HEALF_CONTACT_UK = {
  name: "Lestat McCree",
  email: "orders@healf.com",
  phoneNumber: "+447531500081"
};
